// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GeneratePdfFromTemplateRequestContent } from './generatePdfFromTemplateRequestContent.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class GeneratePdfFromTemplateRequest {
    'filename': string;
    'template': string;
    'contents': Array<GeneratePdfFromTemplateRequestContent>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof GeneratePdfFromTemplateRequest>> = [
        {
            "name":     "filename",
            "baseName": "filename",
            "type":     "string"
        },
        {
            "name":     "template",
            "baseName": "template",
            "type":     "string"
        },
        {
            "name":     "contents",
            "baseName": "contents",
            "type":     "Array<GeneratePdfFromTemplateRequestContent>"
        },
    ];

    static getAttributeTypeMap() {
        return GeneratePdfFromTemplateRequest.attributeTypeMap;
    }
}
